<template>
    <el-container class="assets-page" v-wechat-title="$route.meta.title">
        <el-container class="assets-content">
            <!-- <el-aside>
                <div class="menu-title">
                    <h4>API 列表</h4>
                </div>
            </el-aside> -->
            <el-container>
                <el-main class="el-main">
                    <div class="table-title column-header">
                        <div class="table-title-left">
                            <span>资金需求</span>
                            <!-- <el-checkbox v-model="totalChecked" @change="apiTotalEvent">所有</el-checkbox>
                            <select v-model="apiSelected" @change="apiSelectEvent">
                                <option v-for="(api, index) in apiNameList" :key="index" :label="api.name" :value="index">{{api.name}}</option>
                            </select> -->
                        </div>
                    </div>
                    <div class="table-description"> 
                        <div class="demand-table" v-for="(table, index) in tableData" :key="'table-'+index">
                            <div class="demand-table-title">
                                <span>{{getApiName(index)}}</span>
                                <span v-for="(currency, index_c) in table['1']" :key="'currency'+index_c">{{index_c}}</span>
                            </div>
                            <div class="demand-table-body">
                                <div class="demand-table-body-item" v-for="(type, index_t) in table" :key="'type-'+index_t">
                                    <span>{{index_t}}</span>
                                    <span v-for="(cur, index_cu) in type" :key="'cur-'+index_cu" :style="{'color': dataBgc(cur)}">{{cur}}</span>
                                    <!-- <span v-if="index_t !== '1'"></span> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </el-main>
            </el-container>
        </el-container>
        <Footer ref="childFooter"></Footer>
    </el-container>
</template>

<script>
/* eslint-disable */
import Header from '@/components/header/Header.vue'
import Footer from '@/components/Footer/New-footer.vue'
import { mapState, mapActions } from 'vuex'
import { get } from '@/api/index' 
import { url_CM } from '@/api/config'

export default {
    components: {
        Header,
        Footer,
    },
    data() {
        return{
            demandSocket: null,
            demandTimer: null,
            tableData: {},
            apiList: [],
        }
    },
    mounted() {
        this.initSocket();
        this.getApiList();
        window.addEventListener('beforeunload', e => {
            clearInterval(this.demandTimer);
            // clearInterval(this.timeTimer);
            this.demandSocket.close();
        })
    },
    computed: {
        ...mapState([
            'token'
        ]),
    },
    methods: {
        ...mapActions([

        ]),

        // 创建 websocket
        initSocket() {
            var url = 'ws://'+url_CM.split('//')[1]+'/ts/req'
            this.demandSocket = new WebSocket(url)
            this.initTestSocket()
        },

        // 初始化 websocket 函数
        initTestSocket() {
            this.demandSocket.onopen = this.socketOpen;
            this.demandSocket.onmessage = this.getSocketMsg;
            this.demandSocket.onerror = this.socketError;
            this.demandSocket.onclose = this.socketClose;
        },

        // websocket send
        socketOpen() {
            console.log('连接成功')
            this.demandSocket.send('1')
            this.demandTimer = setInterval(() => {
                this.demandSocket.send('1')
            }, 1300)

            this.$once('hook:beforeDestroy', () => {
                clearInterval(this.demandTimer)
                this.demandSocket.close()
            })
        },

        // websocket 接收函数
        getSocketMsg(resp) {
            // console.log(resp);
            if (resp.data == 'ok') {
                
            } else {
                var resp_data = JSON.parse(resp.data)
                this.tableData = resp_data;
            }
        },
        
        // websocket 异常函数
        socketError(e) {
            clearInterval(this.demandTimer)
            this.demandSocket.close()
            console.warn(e)
        },

        // websocket 关闭函数
        socketClose(e) {
            this.demandSocket.send('0')
            clearInterval(this.demandTimer);
            console.warn('webSocket 连接关闭：', e.code);
        },

        // 背景颜色判断
        dataBgc(data) {
            if (data !== 0) {
                return '#db5634';
            }
        },

        // 获取api列表
        getApiList() {
            let url = this.$baseUrl + '/api/list';
            let param = {
                'token': this.token
            };

            get(url, param).then(resp => {
                if (resp.code == 200) {
                    this.apiList = resp.data;
                } else {
                    this.$notify.error({
                        message: resp.info,
                        title: '提示',
                        offset: 100
                    })
                }
            })
        },

        // 将apiId 转换为api名字
        getApiName(apiId) {
            for (let i=0; i<this.apiList.length; i++) {
                if (this.apiList[i].id == apiId) {
                    return this.apiList[i].name;
                }
            }
        }

    }
}
</script>

<style lang="scss">
    .assets-page{
        ::-webkit-scrollbar{
            width: 12px;
        }
        ::-webkit-scrollbar-track{
            // color: #1e1e1e;
            box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
            // border-radius: 10px;
            background-color: #2A2D2E;
        }
        ::-webkit-scrollbar-thumb{
            border-radius: 10px;
            background: rgba(122, 121, 121, 0.1);
            box-shadow: inset 0 0 6px rgba(124, 124, 124, 0.5);
        }
        .el-container{
            // padding: 20px 20px;
            .el-aside{
                // min-width: 150px;
                width: 150px !important;
                background-color: #2A2D2E;
                .menu-title{
                    padding: 10px;
                    color: #686869;
                    text-align: left;
                    background-color: #1e1e1e;
                }
                .el-menu{
                    background-color: #2A2D2E;
                    border: 0;
                    .el-menu-item{
                        color: #A7A7A7;
                        font-size: 13px;
                        padding: 3px;
                        line-height: 30px;
                        height: 30px;
                        text-align: left;
                        padding-left: 5px !important;
                    }
                    .el-menu-item:hover{
                        background-color: #575656;
                        color: #fff;
                    }
                }
            }
            .el-container{
                background-color: #2A2D2E;
                margin-left: 10px;
                padding: 0 0 20px 0;
                .el-main{
                    text-align: left;
                    color: #686869;
                    background-color: #2A2D2E;
                    .table-title{
                        display: flex;
                        justify-content: space-between;
                        border-bottom: 1px solid #1e1e1e;
                        background-color: #1e1e1e;
                        .table-title-contral{
                            .el-badge{
                                margin-right: 10px;
                                .el-badge__content{
                                    background-color: #db5634;
                                    border: 1px solid #db5634;
                                    height: 12px;
                                    line-height: 12px;
                                    padding: 0 2px;
                                    top: 3px;
                                    right: 7px;
                                }
                                span{
                                    font-size: 12px;
                                }
                                span:hover{
                                    cursor: pointer;
                                    color: #969292;
                                }
                            }
                        }
                        .el-dialog__body{
                            background-color: #262829;
                            box-shadow: 0 0 10px #6f6c6c;
                        }
                        .chart-time-select{
                            text-align: center;
                            margin-top: 10px;
                            span{
                                margin-right: 10px;
                                color: #969292;
                            }
                            span:hover{
                                cursor: pointer;
                            }
                        }
                        .table-title-left{
                            display: flex;
                            justify-content: flex-start;
                            select{
                                margin-left: 10px;
                                background-color: #2a2d2e;
                                border: 1px solid #2a2d2e;
                                color: #969292;
                            }
                            .el-checkbox{
                                margin-left: 10px;
                                .el-checkbox__label{
                                    padding-left: 5px;
                                }
                            }
                            .el-input__inner{
                                height: 25px;
                                line-height: 25px;
                                font-size: 12px;
                                padding-right: 20px;
                                background-color: #262829;
                                border-color: #262829;
                                color: #A7A7A7;
                            }
                            .el-input__icon{
                                line-height: 25px;
                            }

                        }
                        .chart-title{
                            padding: 10px;
                            h3{
                                text-align: center;
                            }
                        }
                    }    

                    .table-description{
                        background-color: #2a2d2e;
                        .demand-table{
                            width: 100%;
                            background-color: #262829;
                            margin-bottom: 10px;
                            .demand-table-title{
                                display: flex;
                                justify-content: space-between;
                                background-color: #1e1e1e;
                                padding: 3px 0;
                                span{
                                    flex: 1;
                                }
                            }
                            .demand-table-body{
                                .demand-table-body-item {
                                    display: flex;
                                    justify-content: flex-start;
                                    padding: 3px 0;
                                    border-bottom: 1px solid #383636;
                                    span{
                                        flex: 1;
                                    }
                                }
                                :nth-last-child(1) {
                                    border: 0;
                                }

                                .demand-table-body-item:hover {
                                    background-color: #1e1e1e;
                                }
                            }
                        }
                    }              
                }
            }
            
        }
    }

    @media screen and (max-width: 1200px) {
        .assets-page{
            .el-container{
                padding: 20px 5px;
                .el-aside{
                    display: none;
                }
                .el-container{
                    margin-left: 0;
                    padding: 10px 0;
                    .el-main{
                        .table-title{
                            .table-title-left{
                                h3{
                                    font-size: 0.6rem;
                                }
                                .el-input__inner{
                                    padding-right: 1px;
                                    padding-left: 5px;
                                }
                            }
                            .el-button{
                                padding: 3px 5px;
                                font-size: 12px;
                            }
                        }
                    }
                }
            }
        }
    }
    @media screen and (max-width: 680px) {
        .assets-page{
            .el-dialog{
                width: 350px !important;
            }
            .message-notification{
                display: none;
            }
        }
    }
    @media screen and (max-width: 420px) {
        .assets-page{
            .el-container{
                padding: 0px;
                margin: 0 3px;
            }
        }
    }
    
</style>

